import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {TabPanel} from "./TabPanelComponent";
import {ProductComponent} from "./ProductComponent";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import {BasketComponent} from "./BasketComponent";
import AliceCarousel from "react-alice-carousel";
import PositionedMenu from "./PositionedMenu";
import {BackButton, BottomMenu} from './HookUtils';
import {Link} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import WhatsAppOutlinedIcon from "@mui/icons-material/WhatsApp";
import InstagramOutlinedIcon from "@mui/icons-material/Instagram";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

export class ProductCollectionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchedCategories: [],
            value: 0,
            marketInfo: {},
            open: false,
            popUpOpen: false,

        };
    }


    componentDidMount() {
        fetch(BASE_URL_API + 'market/' + this.props.id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                if (results.code === 200) {
                    this.setState({marketInfo: results.data});
                }
            })
            .catch((error) => console.log("market error", error));

        fetch(BASE_URL_API + 'subCategory?market_id=' + this.props.id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                this.setState({fetchedCategories: results.data});
            })
            .catch((error) => console.log("subcategory error", error));
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue});
    };

    render() {

        const {marketInfo, value, fetchedCategories, step} = this.state;

        const renderMarketHeader = (marketInfo) => {

            const pics = Array.isArray(marketInfo?.pictures) ? marketInfo.pictures : [];
            const imgSrcs = pics.map((p) => MARKET_BASE_URL_API + p.url);

            return (
                <Paper
                    elevation={0}
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: 3,
                        mx: 1,
                        mb: 1.5,
                        mt: 15,
                        backgroundColor: "#fff",
                        boxShadow: "0 10px 26px rgba(0,0,0,0.08)",
                    }}
                >
                    {/* === Banner / Carousel (background layer) === */}
                    <Box sx={{position: "relative"}}>
                        <AliceCarousel
                            autoPlay
                            infinite
                            mouseTracking
                            disableDotsControls={true}
                            disableButtonsControls={true}
                            animationDuration={700}
                            autoPlayInterval={2800}
                            renderPrevButton={({isDisabled}) => (
                                <IconButton
                                    disabled={isDisabled}
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: 12,
                                        transform: "translateY(-50%)",
                                        bgcolor: "rgba(255,255,255,0.9)",
                                        "&:hover": {bgcolor: "#fff"},
                                        boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                                        width: 36,
                                        height: 36,
                                        zIndex: 4,
                                    }}
                                >
                                    <ArrowBackIosNewRoundedIcon sx={{fontSize: 18}}/>
                                </IconButton>
                            )}
                            renderNextButton={({isDisabled}) => (
                                <IconButton
                                    disabled={isDisabled}
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        right: 12,
                                        transform: "translateY(-50%)",
                                        bgcolor: "rgba(255,255,255,0.9)",
                                        "&:hover": {bgcolor: "#fff"},
                                        boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                                        width: 36,
                                        height: 36,
                                        zIndex: 4,
                                    }}
                                >
                                    <ArrowForwardIosRoundedIcon sx={{fontSize: 18}}/>
                                </IconButton>
                            )}
                            renderDotsItem={({isActive}) => (
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: isActive ? 18 : 8,
                                        height: 8,
                                        borderRadius: 999,
                                        marginInline: 4,
                                        background: isActive ? "#9a1111" : "rgba(255,255,255,0.6)",
                                        boxShadow: isActive
                                            ? "0 2px 8px rgba(154,17,17,0.4)"
                                            : "none",
                                        transition: "all .25s ease",
                                    }}
                                />
                            )}
                            items={(imgSrcs.length ? imgSrcs : [null]).map((src, idx) => (
                                <Box
                                    key={idx}
                                    sx={{
                                        width: "100%",
                                        height: 220, // 👈 fixed Paper height — adjust as needed (e.g., 280–320)
                                        background: src
                                            ? `url(${src}) center center / contain no-repeat` // ✅ fills entire height
                                            : "#f5f5f5",
                                        position: "relative",
                                    }}
                                />
                            ))}

                        />

                        {/* Shadow gradient (behind info, inside Paper) */}
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                background:
                                    "linear-gradient(to top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 20%, rgba(0,0,0,0.0) 100%)",
                                zIndex: 1,
                            }}
                        />
                    </Box>

                    {/* === Market info overlay === */}
                    <Box
                        sx={{
                            position: "absolute",
                            insetInline: 0,
                            bottom: 0,
                            zIndex: 3, // 👈 above gradient
                            px: 2,
                            pt: 6,
                            pb: 0, // ✅ more bottom padding so chips stay inside box
                            color: "#fff",
                            direction: "rtl",
                        }}
                    >
                        {/* Market name */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 900,
                                fontFamily: "RokhFaNum, Arial, sans-serif",
                                textShadow: "0 2px 10px rgba(0,0,0,0.35)",
                                display: "flex",
                                alignItems: "baseline",
                                gap: 1,
                                mb: 0.5,
                            }}
                        >
                            {marketInfo?.name || "نام فروشگاه"}
                        </Typography>

                        {/* Description */}
                        {marketInfo?.content && (
                            <Typography
                                variant="body2"
                                sx={{
                                    opacity: 0.98,
                                    maxWidth: "92%",
                                    textShadow: "0 2px 10px rgba(0,0,0,0.25)",
                                    lineHeight: 1.6,
                                }}
                            >
                                {marketInfo.content}
                            </Typography>
                        )}

                        {/* Info chips (inside box now) */}

                    </Box>

                </Paper>
            );
        };

        const shipping =
            marketInfo?.shipping
                ? Number(marketInfo.shipping).toLocaleString("fa-IR") + " تومان"
                : null;
        const categoryTitle = marketInfo?.category?.title;
        const insta =
            marketInfo?.instagram && marketInfo.instagram !== "none"
                ? String(marketInfo.instagram).replace(/^@/, "")
                : null;

        return (
            <div style={{
                backgroundColor: "#ffffff",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
            }}>
                <AppBar elevation={0}
                        sx={{background: "rgba(238,238,238,0.3)", backdropFilter: "blur(6px)"}}>
                    <ToolbarMui
                        disableGutters
                        sx={{
                            px: 1,
                            minHeight: {xs: 48, sm: 56},          // shorter toolbar on mobile
                            gap: 0.5,
                        }}
                    >
                        {/* Left actions (in RTL this appears on the right visually) */}
                        <PositionedMenu marketInfo={marketInfo}
                                        iconSx={{fontSize: 22}}                // and smaller icon if supported
                        />
                        {/* Title (center, clamps + ellipsis) */}
                        <Typography
                            variant="subtitle2"
                            component="div"
                            sx={{
                                mx: 1,
                                flex: "1 1 auto",
                                textAlign: "center",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontWeight: 900, // stronger bold
                                fontSize: "1rem",
                                letterSpacing: "0.3px",
                                color: "#fff", // pure white text
                                textShadow: `
      0 0 4px rgba(255, 255, 255, 0.7),
      0 0 8px rgba(255, 100, 100, 0.5),
      0 0 12px rgba(255, 17, 17, 0.45)
    `, // glowing highlight
                                background: "linear-gradient(90deg, #ff1744, #ff5252, #fff)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent", // gradient text
                                animation: "shineMove 2s linear infinite",
                                "@keyframes shineMove": {
                                    "0%": {backgroundPosition: "0% 50%"},
                                    "100%": {backgroundPosition: "200% 50%"},
                                },
                                backgroundSize: "200% auto",
                            }}
                            title={marketInfo.name}
                        >
                            {marketInfo.name}
                        </Typography>


                        {/* Right actions */}
                        <Box sx={{display: "flex", alignItems: "center"}}>

                            <IconButton
                                component={Link}
                                to="/search"

                                aria-label="جستجو"
                            >
                                <SearchIcon compact/>
                            </IconButton>

                            <IconButton aria-label="سبد">
                                <BasketComponent compact/>
                            </IconButton>


                            <BackButton style={{marginRight: 4}}/>

                        </Box>
                    </ToolbarMui>

                    <Tabs
                        variant="scrollable"
                        value={value}
                        onChange={this.handleChange}
                        textColor="secondary"
                        indicatorColor="primary"
                    >
                        <Tab key="all-products" label="همه محصولات" sx={{fontWeight: "bold"}}/>
                        {fetchedCategories.map((category) => (
                            <Tab key={category.id} label={category.title} sx={{fontWeight: "bold"}}/>
                        ))}
                    </Tabs>
                </AppBar>
                {/* ALL PRODUCTS TAB */}

                {renderMarketHeader(marketInfo)}

                <Box
                    sx={{
                        m: 1.5,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.75,
                        alignItems: "center",
                    }}
                >
                    {/* ☎️ Phone */}
                    {marketInfo?.tell && (
                        <Chip
                            icon={<PhoneOutlinedIcon sx={{fontSize: 18}}/>}
                            label={marketInfo.tell}
                            clickable
                            sx={{
                                height: 30,
                                borderRadius: "8px",
                                bgcolor: "rgba(255,255,255,0.95)",
                                border: "2px solid rgba(137,137,137,1)",
                                "&:hover": {bgcolor: "#fff"},
                                "& .MuiChip-label": {
                                    fontWeight: 700,
                                    fontSize: 13,
                                    px: 1.2,
                                    display: "flex",
                                    alignItems: "center",
                                },
                                "& .MuiChip-icon": {
                                    fontSize: 18,
                                    mr: 0.3,
                                    color: "#444",
                                },
                            }}
                        />
                    )}

                    {/* 💬 WhatsApp */}
                    {marketInfo?.whatsapp && (
                        <Tooltip title="WhatsApp" arrow>
                            <Chip
                                icon={<WhatsAppOutlinedIcon sx={{fontSize: 18, color: "#25D366"}}/>}
                                label={marketInfo.whatsapp}
                                clickable
                                component="a"
                                href={`https://wa.me/${marketInfo.whatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                                sx={{
                                    height: 30,
                                    borderRadius: "8px",
                                    bgcolor: "rgba(255,255,255,0.95)",
                                    border: "2px solid rgba(137,137,137,1)",
                                    "&:hover": {bgcolor: "#ffffff"},
                                    "& .MuiChip-label": {
                                        fontWeight: 700,
                                        fontSize: 13,
                                        px: 1.2,
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    "& .MuiChip-icon": {
                                        mr: 0.3,
                                        fontSize: 18,
                                    },
                                }}
                            />
                        </Tooltip>
                    )}

                    {/* 🚚 Shipping */}
                    {shipping && (
                        <Chip
                            icon={<LocalShippingOutlinedIcon sx={{fontSize: 18}}/>}
                            label={`هزینه ارسال: ${shipping}`}
                            sx={{
                                height: 30,
                                borderRadius: "8px",
                                bgcolor: "rgba(255,255,255,0.95)",
                                border: "2px solid rgba(137,137,137,1)",
                                "& .MuiChip-label": {
                                    fontWeight: 700,
                                    fontSize: 13,
                                    px: 1.2,
                                    display: "flex",
                                    alignItems: "center",
                                },
                                "& .MuiChip-icon": {
                                    fontSize: 18,
                                    mr: 0.3,
                                    color: "#555",
                                },
                            }}
                        />
                    )}

                    {/* 🏷️ Category */}
                    {categoryTitle && (
                        <Chip
                            icon={<CategoryOutlinedIcon sx={{fontSize: 18}}/>}
                            label={categoryTitle}
                            sx={{
                                height: 30,
                                borderRadius: "8px",
                                bgcolor: "rgba(255,255,255,0.95)",
                                border: "2px solid rgba(137,137,137,1)",
                                "& .MuiChip-label": {
                                    fontWeight: 700,
                                    fontSize: 13,
                                    px: 1.2,
                                    display: "flex",
                                    alignItems: "center",
                                },
                                "& .MuiChip-icon": {
                                    fontSize: 18,
                                    mr: 0.3,
                                    color: "#555",
                                },
                            }}
                        />
                    )}

                    {/* 📸 Instagram */}
                    {insta && (
                        <Tooltip title="Instagram" arrow>
                            <Chip
                                icon={<InstagramOutlinedIcon sx={{fontSize: 18, color: "#E1306C"}}/>}
                                label={`@${insta}`}
                                clickable
                                component="a"
                                href={`https://instagram.com/${insta}`}
                                target="_blank"
                                rel="noreferrer"
                                sx={{
                                    height: 30,
                                    borderRadius: "8px",
                                    bgcolor: "rgba(255,255,255,0.95)",
                                    border: "2px solid rgba(137,137,137,1)",
                                    "&:hover": {bgcolor: "#fff"},
                                    "& .MuiChip-label": {
                                        fontWeight: 700,
                                        fontSize: 13,
                                        px: 1.2,
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    "& .MuiChip-icon": {
                                        mr: 0.3,
                                        fontSize: 18,
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                </Box>

                <TabPanel value={value} index={0}>
                    <ProductComponent market_id={this.props.id} category_id={-1}/>
                </TabPanel>
                {/* CATEGORIZED PRODUCTS */}
                {fetchedCategories.map((category, index) => (
                    <TabPanel key={category.id} value={value} index={index + 1}>
                        <ProductComponent market_id={this.props.id} category_id={category.id}/>
                    </TabPanel>
                ))}
                <BottomMenu/>
            </div>
        );
    }
}
